const $ = jQuery

export default function Accordion () {
  const ACCORDIONS = document.querySelectorAll('.accordion')
  if (ACCORDIONS.length > 0) {
    for (let i = 0; i < ACCORDIONS.length; i++) {
      const ACCORDION = ACCORDIONS[i]
      const TITLE = ACCORDION.querySelector('.accordion-title')
      TITLE && TITLE.addEventListener('click', () => {
        $(ACCORDION).toggleClass('active').siblings().removeClass('active')
      })
    }
  }
}
